<template>
  <div class="v3-widget v3-panel" v-testid="testid">
    <div class="v3-panel-head">
      <h3 v-testid="testid + '-title'">{{ title }}</h3>
      <span v-if="cb.count.value" class="sub">{{ cb.count.value }} awaiting review in context</span>
    </div>

    <!-- Anchor roles (PD-1258): the framework's hard top, stated whether or not the
         holder appears in the rows below — on a real register it usually won't, since
         the CEO is rarely an outlier against its own function. Empty (and so hidden)
         until the payload arrives, and for tenants without a ceiling. -->
    <div v-if="cb.ceilingText.value" class="v3-cal-ceiling">
      <span class="ms">vertical_align_top</span> {{ cb.ceilingText.value }}
    </div>

    <V3Skeleton v-if="cb.isLoading.value && !cb.count.value" shape="list" :heading="false" />
    <div v-else-if="!cb.count.value" class="v3-task-empty" v-testid="testid + '-empty'">Everything's in line with peers.</div>

    <div v-else class="v3-list">
      <div
        v-for="r in cb.shownRows.value"
        :key="r.doc_id"
        class="v3-row v3-row--cal"
        role="button"
        tabindex="0"
        v-testid="testid + '-row-' + r.doc_id"
        @click="open(r)"
      >
        <span class="v3-anom">
          <span class="v3-anom-ic" :class="cb.isAnomaly(r) ? 'v3-anom-ic--high' : 'v3-anom-ic--low'"><span class="ms">balance</span></span>
          <span class="v3-anom-main">
            <span class="v3-row-title">
              <!-- Anchor / CEO ceiling mark (PD-1258): the reference the other rows
                   are calibrated against, so it reads before the role name. -->
            <span
              v-if="cb.anchorMark(r)"
              class="v3-cal-mark"
              :class="{ 'is-ceiling': cb.anchorMark(r).isCeiling }"
              :title="cb.anchorMark(r).tip"
            ><span class="ms">{{ cb.anchorMark(r).icon }}</span> {{ cb.anchorMark(r).short }}</span>
              {{ cb.role(r) }}
            </span>
            <span class="v3-row-sub">{{ cb.rowSub(r) }}</span>
          </span>
        </span>
        <span class="v3-level">{{ cb.levelText(r) }}</span>
        <button class="v3-notif-cta" type="button" v-testid="testid + '-row-' + r.doc_id + '-view'" @click.stop="open(r)">View in context</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { calibration } from "@rm-ui/homepage/calibration";
import V3Skeleton from "./cLandingV3Skeleton";

// New-portal (v3) Calibration — roles to review in context vs peers (prototype
// V3Calibration) over the shared `calibration` composable (POST
// Report/calibration). Sibling: rm-portal-beta CalibrationWidget.vue.
export default {
  name: "cLandingV3Calibration",
  components: { V3Skeleton },
  props: {
    definition: { type: Object, default: () => ({}) },
    editMode: { type: Boolean, default: false },
    qaActions: { type: Array, default: () => [] },
  },
  setup(props) {
    const cb = calibration({
      http: axios,
      getLimit: () => props.definition.limit || 8,
    });
    return { cb };
  },
  computed: {
    testid() {
      return this.definition.controlType || "v3Calibration";
    },
    title() {
      return this.definition.title || "Calibration";
    },
  },
  methods: {
    open(r) {
      if (this.editMode) return;
      const reference = r.reference || r.system_number;
      if (reference) this.$emit("openDocument", { system_number: reference, reference });
    },
  },
};
</script>

<style lang="scss" src="./v3Widgets.scss"></style>
